
import React, { Component } from 'react';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import { API_URL, STORAGE_URL, URL } from '../../variables';

import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';



import { FormControlLabel, Radio, TextField } from '@material-ui/core';
import './label.css';
import 'moment/locale/pt-br';

import { createGlobalStyle } from 'styled-components';
import { FaPlus, FaTrash } from 'react-icons/fa';
import JoditEditor from 'jodit-react';


const StyleQuestion = createGlobalStyle`
 p {
letter-spacing: 0.2px;
margin-bottom: 3px;
 }
`

class EditarEntrevista extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: true,
            roles: [],
            name: '',
            descricao: '',
            topicos: [],
            criterios: [],
            loading_save: false,
            msgErro: '',
            loading_image: false,
            loading_image_info: false,
            info:''
        };

        this.config_info = {
                    height: 300,
                    // askBeforePasteHTML:false,
                    // askBeforePasteFromWord:false,
                    // defaultActionOnPaste:'insert_only_text',
                    // defaultActionOnPasteFromWord:'insert_only_text',
                    // pasteHTMLActionList:[
                    //     { value: 'insert_only_text', text: 'Insert only Text' }
                    // ],
                    // pasteFromWordActionList:[
                    //     { value: 'insert_only_text', text: 'Insert only Text' }
                    // ],
                    readonly: this.state.loading_image_info,
                    language: 'pt_br',
                    toolbarButtonSize: 'large',
                    "buttons": "source,bold,italic,underline,strikethrough,eraser,superscript,subscript,ul,ol,indent,outdent,left,center,right,justify,font,fontsize,paragraph,classSpan,image,brush,,undo,redo,hr,link,symbol,table",
                    uploader: {
                        url: API_URL + 'faculdade/upload_image',  //your upload api url
                        insertImageAsBase64URI: true, //not inster base64
                        imagesExtensions: ['jpg', 'png', 'jpeg', 'gif'],
                        headers: { "accept": `application/json`, 'Authorization': 'Bearer ' + localStorage.getItem('token') },
                        filesVariableName: function (t) {
                            return 'imagem';
                        }, //"files",
                        withCredentials: false,
                        pathVariableName: 'path',
                        //   format: 'json',
                        method: 'POST',
                        prepareData: (formdata) => {
                            console.log(formdata)
                            this.setState({ loading_image_info: true });
                            return formdata;
                        },
                        isSuccess: (e) => {
                            console.log(e);
        
                            return 'Upload realizado com sucesso';
                        },
                        getMessage: (e) => {
                            console.log(e);
        
                            return e;
                        },
                        process: (resp) => { //success callback transfrom data to defaultHandlerSuccess use.it's up to you.
                            let files = [];
                            console.log(resp);
                            files.unshift(STORAGE_URL + resp.imagem);
                            this.setState({ loading_image_info: false });
        
                            return {
                                files: files,
        
                            };
                        },
                        error: (elem, e) => {
                            // elem.j.e.fire('errorMessage', e.message, 'error', 4000);
        
                            console.log(e);
                            console.log(elem);
                            console.log('Bearer ' + localStorage.getItem('token'));
                        },
                        defaultHandlerSuccess: function (resp, elem) { // `this` is the editor.
                            if (resp.files && resp.files.length) {
                                resp.files.forEach((filename, index) => { //edetor insertimg function
                                    this.selection.insertImage(filename);
                                });
                            }
        
                            // debugger;
        
                        },
                        defaultHandlerError: (elem, e) => {
                            // elem.j.e.fire('errorMessage', e.message);
                            console.log(e);
                            console.log(elem);
                            this.setState({ loading_image_info: false });
        
                        },
                        //   contentType: function (e) {
                        //     return (
        
                        //       'application/x-www-form-urlencoded; charset=UTF-8'
                        //     );
                        //   },
                    },
                }

        this.config = {
            height: 300,
            // askBeforePasteHTML:false,
            // askBeforePasteFromWord:false,
            // defaultActionOnPaste:'insert_only_text',
            // defaultActionOnPasteFromWord:'insert_only_text',
            // pasteHTMLActionList:[
            //     { value: 'insert_only_text', text: 'Insert only Text' }
            // ],
            // pasteFromWordActionList:[
            //     { value: 'insert_only_text', text: 'Insert only Text' }
            // ],
            readonly: this.state.loading_image,
            language: 'pt_br',
            toolbarButtonSize: 'large',
            "buttons": "source,bold,italic,underline,strikethrough,eraser,superscript,subscript,ul,ol,indent,outdent,left,center,right,justify,font,fontsize,paragraph,classSpan,image,brush,,undo,redo,hr,link,symbol,table",
            uploader: {
                url: API_URL + 'faculdade/upload_image',  //your upload api url
                insertImageAsBase64URI: true, //not inster base64
                imagesExtensions: ['jpg', 'png', 'jpeg', 'gif'],
                headers: { "accept": `application/json`, 'Authorization': 'Bearer ' + localStorage.getItem('token') },
                filesVariableName: function (t) {
                    return 'imagem';
                }, //"files",
                withCredentials: false,
                pathVariableName: 'path',
                //   format: 'json',
                method: 'POST',
                prepareData: (formdata) => {
                    console.log(formdata)
                    this.setState({ loading_image: true });
                    return formdata;
                },
                isSuccess: (e) => {
                    console.log(e);

                    return 'Upload realizado com sucesso';
                },
                getMessage: (e) => {
                    console.log(e);

                    return e;
                },
                process: (resp) => { //success callback transfrom data to defaultHandlerSuccess use.it's up to you.
                    let files = [];
                    console.log(resp);
                    files.unshift(STORAGE_URL + resp.imagem);
                    this.setState({ loading_image: false });

                    return {
                        files: files,

                    };
                },
                error: (elem, e) => {
                    // elem.j.e.fire('errorMessage', e.message, 'error', 4000);

                    console.log(e);
                    console.log(elem);
                    console.log('Bearer ' + localStorage.getItem('token'));
                },
                defaultHandlerSuccess: function (resp, elem) { // `this` is the editor.
                    if (resp.files && resp.files.length) {
                        resp.files.forEach((filename, index) => { //edetor insertimg function
                            this.selection.insertImage(filename);
                        });
                    }

                    // debugger;

                },
                defaultHandlerError: (elem, e) => {
                    // elem.j.e.fire('errorMessage', e.message);
                    console.log(e);
                    console.log(elem);
                    this.setState({ loading_image: false });

                },
                //   contentType: function (e) {
                //     return (

                //       'application/x-www-form-urlencoded; charset=UTF-8'
                //     );
                //   },
            },
        }


    }

    get_entrevista(id) {

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/faculdade/get_entrevista/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                   
                }
                else {
                    // this.props.mudarUser(resp.user);
                    

                    this.setState({
                        loading_screen: false, processo: resp.entrevista.processo,
                        name: resp.entrevista.name,
                        descricao: resp.entrevista.descricao,
                        info:resp.entrevista.info ?? '',
                        topicos: resp.entrevista.topicos.map((item)=>item.text),
                        criterios: resp.entrevista.criterios,
                    });
                    // if (resp.processo != null) {

                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        })
            .catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }



    salvar(e) {
        e.preventDefault();
        this.setState({ loading_save: true, msgErro: '' });
        let data = {};
        data.name = this.state.name;
        data.info = this.state.info;

        data.descricao = this.state.descricao;
        data.criterios = this.state.criterios;
        data.topicos = this.state.topicos;
        data.entrevista_id = this.props.match.params.id;


        fetch(`${URL}api/faculdade/update_entrevista`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
            },
            body: JSON.stringify(data)
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                if (resp.errors != null || resp.error != null  || resp.message) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    window.scrollTo(500, 0);

                    this.setState({ loading_save: false, msgErro: erro });
                }
                else {
                    this.setState({ loading_save: false, redirect: true });
                }




            } catch (err) {
                console.log(err);
                this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor' });

            }

        })
            .catch((err) => {
                console.log(err);
                this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?' });
            });
    }


    componentDidMount() {
        this.get_entrevista(this.props.match.params.id);
    }



    render() {
        return (
            <div className="row">
                {this.state.redirect == true && <Redirect to={`/processos/show/${this.state.processo.id}?tab=9`} />}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card" style={{ overflow: 'visible' }}>

                            <div hidden id="text_enunciado">

                            </div>
                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Editar entrevista</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>Edite uma entrevista {(this.props.user.empresa==null || this.props.user.empresa.change_text==false)?'do processo':'da vaga/cargo'} {this.state.processo?.name}</p>
                            <br />
                            
                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>
                                <StyleQuestion />
                                {this.state.msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                                    <div className="alert alert-danger alert-dismissible fade show mb-0 w-100" role="alert">
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ msgErro: '' })}></button>


                                        <p style={{ marginBottom: 0 }}>{this.state.msgErro}</p>

                                    </div>
                                    <br />

                                </div>}

                                <Form onSubmit={(e) => this.salvar(e)} style={{ position: "relative" }}>
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>Nome <Attention /></Form.Label>
                                            <Input
                                                placeholder="Nome da entrevista"
                                                value={this.state.name}
                                                onChange={(e) => this.setState({ name: e.target.value })}
                                                required
                                            // title="Coloque o nome completo do usuário"
                                            />
                                        </div>
                                    </InputGroup>

                                     <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label >Informação Geral <Attention /> {this.state.loading_image == true && <div className="spinner-border text-primary spinner-border-sm" role="status"  >
                                            </div>}</Form.Label>
                                            <JoditEditor
                                                ref={this.editor}
                                                value={this.state.descricao}
                                                config={this.config}
                                                height={400}
                                                tabIndex={1} // tabIndex of textarea
                                                onBlur={newContent => this.setState({ descricao: newContent })} // preferred to use only this option to update the content for performance reasons
                                            // onChange={newContent => {this.setState({enunciado:newContent}) }}
                                            />
                                        </div>
                                    </InputGroup>

                                  

                                   
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label >Tópicos </Form.Label>
                                            {this.state.topicos.map((item, id) => (
                                                <div className='d-flex mt-2 justify-content-center align-items-center'>
                                                    <div style={{ background: 'black', borderRadius: 100, width: 10, height: 10, marginRight: 10 }}>
                                                    </div>
                                                    <TextField
                                                        key={id}
                                                        placeholder="Texto do tópico"
                                                    value={item}
                                                        type="search"
                                                        variant="standard"
                                                        style={{ width: '100%' }}
                                                        onChange={(e) => {
                                                            let topicos = [...this.state.topicos];
                                                            topicos[id] = e.target.value;
                                                            this.setState({ topicos })
                                                        }}
                                                        required
                                                    />

                                                </div>
                                            ))}
                                            <div className='d-flex justify-content-end mt-3'>
                                                <Button onClick={() => {
                                                    let topicos = [...this.state.topicos];
                                                    topicos.pop();
                                                    this.setState({ topicos })
                                                }} variant="outline-danger" className="flex align-center jcc me-1"><FaTrash style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Remover tópico</p></Button>
                                                <Button onClick={() => {
                                                    let topicos = [...this.state.topicos];
                                                    topicos.push('');
                                                    this.setState({ topicos })
                                                }} variant="outline-primary" className="flex align-center jcc"><FaPlus style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Adicionar tópico</p></Button>

                                            </div>

                                        </div>
                                    </InputGroup>
  <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label >Informação para o Avaliador <Attention /> {this.state.loading_image == true && <div className="spinner-border text-primary spinner-border-sm" role="status"  >
                                            </div>}</Form.Label>
                                            <JoditEditor
                                                ref={this.editor_info}
                                                value={this.state.info}
                                                config={this.config_info}
                                                height={400}
                                                tabIndex={1} // tabIndex of textarea
                                                onBlur={newContent => this.setState({ info: newContent })} // preferred to use only this option to update the content for performance reasons
                                            // onChange={newContent => {this.setState({enunciado:newContent}) }}
                                            />
                                        </div>
                                    </InputGroup>

                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label >Critérios <Attention /> </Form.Label>
                                            <div className="table-rep-plugin">
                                                <div className="table-responsive mb-0" data-pattern="priority-columns">
                                                    <table className="table table-striped">
                                                        <thead>
                                                            <tr>

                                                                <th>Código do Critério</th>
                                                                <th>Texto do Critério</th>
                                                                <th>Nota mínima</th>
                                                                <th>Nota máxima</th>
                                                            </tr>

                                                        </thead>
                                                        <tbody >

                                                            {this.state.criterios.map((item, id) => (
                                                                <tr key={id}>
                                                                    <td>
                                                                        <Input
                                                                            placeholder={"Código do critério"}
                                                                            value={item.code}
                                                                            onChange={(e) => {
                                                                                let criterios = [...this.state.criterios];
                                                                                criterios[id].code = e.target.value;
                                                                                this.setState({ criterios })
                                                                            }}
                                                                            required
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                    <Input
                                                                            placeholder={"Texto do critério"}
                                                                            value={item.text}
                                                                            onChange={(e) => {
                                                                                let criterios = [...this.state.criterios];
                                                                                criterios[id].text = e.target.value;
                                                                                this.setState({ criterios })
                                                                            }}
                                                                            required
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                    <Input
                                                                            placeholder={"Nota mínima"}
                                                                            value={item.min_score}
                                                                            type='number'
                                                                            onChange={(e) => {
                                                                                let criterios = [...this.state.criterios];
                                                                                criterios[id].min_score = e.target.value;
                                                                                this.setState({ criterios })
                                                                            }}
                                                                            required
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                    <Input
                                                                            placeholder={"Nota máxima"}
                                                                            value={item.max_score}
                                                                            type='number'
                                                                            onChange={(e) => {
                                                                                let criterios = [...this.state.criterios];
                                                                                criterios[id].max_score = e.target.value;
                                                                                this.setState({ criterios })
                                                                            }}
                                                                            required
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}

                                                            {this.state.criterios.length==0 && <tr >
                                                                <td colSpan="4">Nenhum critério adicionado</td>
                                                                </tr>}



                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                            
                                            <div className='d-flex justify-content-end mt-3'>
                                                <Button onClick={() => {
                                                    let criterios = [...this.state.criterios];
                                                    criterios.pop();
                                                    this.setState({ criterios })
                                                }} variant="outline-danger" className="flex align-center jcc me-1"><FaTrash style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Remover critério</p></Button>
                                                <Button onClick={() => {
                                                    let criterios = [...this.state.criterios];
                                                    criterios.push({code:'C'+(criterios.length+1),text:'',min_score:0,max_score:5});
                                                    this.setState({ criterios })
                                                }} variant="outline-primary" className="flex align-center jcc"><FaPlus style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>Adicionar critério</p></Button>

                                            </div>

                                        </div>
                                    </InputGroup>

                                    {this.state.loading_save == false && <div className="w100 inline-flex jcsb margin-top-1">
                                        {/* <Link to={`/accounts/list`}>
        <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
    </Link> */}
                                        <DefaultButton
                                            bg="secondary"
                                            text="Voltar"
                                            icon={<RiArrowGoBackLine />}
                                            search={'?tab=9'}
                                            to={`/processos/show/${this.state.processo.id}`}
                                        />
                                        {/* <Button variant="success" type="submit" disabled={this.loading}>
        {this.state.loading ? <Spinner /> : ""}
        Registrar usuário
    </Button> */}
                                        <DefaultButton
                                            type="submit"
                                            bg="confirm"
                                            text="Salvar entrevista"
                                            disabled={this.state.loading_image == true}
                                            loadingtext="Salvando entrevista"
                                            loading={this.state.loading_save}
                                        />
                                    </div>}

                                    {this.state.loading_save == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center margin-top-1" >
                                        <div className="spinner-border text-primary" role="status"  >
                                        </div>
                                    </div></div>}
                                </Form>

                            </div>}

                            {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                <div className="spinner-border text-primary" role="status"  >
                                </div>
                            </div></div>}


                        </div>

                    </div>
                </div>
            </div >
        );
    }


}
const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        user: state.AppReducer.user,

    }
);

export default connect(mapsStateToProps, { logout })(EditarEntrevista);


